module.exports = __webpack_public_path__ + "img/about/80243-038.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-038.png
// module id = 36
// module chunks = 0